export default {"src":"/_next/static/media/Award.1c883295.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};